import React, { Component } from "react";
import "./articles.css";
import BlogCard from "./blogcard";

class Articles extends Component {
  componentWillMount() {}
  componentDidMount() {}

  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="BlogList">
        {this.props.blog &&
          this.props.blog.map((obj, index) => {
            // if (obj.showOnBlog){
            // if (count<this.state.max){
            //   count++;
            return (
              <div key={index}>
                <BlogCard blog={obj} mode={this.props.mode} />
                {this.props.mode !== 2 ? (
                  <div className="BlogDivider">&nbsp;</div>
                ) : (
                  ""
                )}
              </div>
            );
            // }
            // }
          })}
      </div>
    );
  }
}

export default Articles;

//<div className="searchBar"><input placeholder="Looking for something we posted?"/></div>
